export default __webpack_public_path__ + "static/media/deportes.2c973dd1.svg";